module.exports = __webpack_public_path__ + "c5d2409763a047f2af48fab8aed528f8.otf";